// plugins/vue-lazyload.js

import Vue from 'vue'
import VueLazyload from 'vue-lazyload'

Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/imgs/imgLazy.jpg',
  loading: '/imgs/imgLazy.jpg',
  attempt: 5
})
